<template>
    <div class="fullHeight">
        <MypageSideMenu :memberDropClose="false"/>
        <Card
            :page_title="page_title"
            iconclass="icon-icon-info mypage-title-icon"
            >
            <div class="col-sm-12">
                <div class="err_msg" v-if="api_error">
                    <p>
                        <span class="text-danger">{{ this.err_msg_txt}}</span>
                    </p>
                </div>
                <div class="form-group row">
                    <div class="col-sm-3 col-form-label">会員番号</div>
                    <div class="col-sm-9 col-form-label text-right text-sm-left">{{ user_data.member_no }}</div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-3 col-form-label">氏名</div>
                    <div class="col-sm-9 col-form-label text-right text-sm-left">{{ user_data.full_name }}</div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-3 col-form-label">性別</div>
                    <div class="col-sm-9 col-form-label text-right text-sm-left">{{ user_data.gender }}</div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-3 col-form-label">生年月日</div>
                    <div class="col-sm-9 col-form-label text-right text-sm-left">{{ user_data.birth_date | replace('-','/') }}</div>
                </div>
                <div class="row mypage-info-record">
                    <div class="col-sm-3 col-form-label">メールアドレス</div>
                    <div class="col-sm-9 col-form-label text-right text-sm-left">{{ user_data.email }}</div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label">携帯番号</label>
                    <div class="col-sm-9">
                        <input
                            id="mobile_number"
                            type="text"
                            :class="{'is-invalid': valid.mobile_number}"
                            class="col form-control"
                            v-model="mobile_number"
                            placeholder="半角数字11桁で入力"
                            @blur="checkInputData"
                            @input="checkInputData"
                        />
                        <div
                            class="invalid-feedback"
                            v-if="valid.mobile_number"
                        >{{ valid_message.mobile_number }}</div>
                    </div>
                </div>
                <div class="mb-3">
                    <div class="row justify-content-center flex-column flex-sm-row px-3">
                        <button
                            type="button"
                            class="bluebackbutton mb-2 col-lg-btn-size"
                            v-on:click="submitChangeMobile"
                            :disabled="submit_disabled"
                            >
                                携帯番号を変更する
                        </button>
                        <button
                            type="button"
                            class="mypagebackbutton mb-2 ml-0 ml-sm-5 col-lg-btn-size"
                            @click="gotoMypageInfo"
                            >戻る
                        </button>
                    </div>
                </div>
                <ConfirmDialog
                    v-if="confirmDialogSw === true"
                    initialMessage=""
                    doing=""
                    notDoing=""
                    :close="btnName"
                    :processing="processing"
                    @closeBtn="onSignupForm"
                />
            </div>
        </Card>
        <MypageMenuFooter/>
    </div>
</template>

<script>
import MypageSideMenu from "./MypageSideMenu";
import MypageHeader from './MypageHeader';
import validater from "../../lib/validater";
import Card from '../components/Card';
import ConfirmDialog from '../components/ConfirmDialog';
import { GET_MEMBER_ID } from "../../constants/signin";
import { GET_MEMBER } from "../../constants/mypage_info";
import { UPDATE_MYPAGE_MOBILE } from '../../constants/mypage_mobile_change';
import { memberStatusMixin } from './memberStatusMixin';
import { MEMBER_LOG_OUT } from "../../constants/signout";
import MypageMenuFooter from './MypageMenuFooter';

export default {
    components: {
        MypageSideMenu,
        MypageMenuFooter,
        MypageHeader,
        validater,
        Card,
        ConfirmDialog
    },
    mixins: [memberStatusMixin],
    data () {
        return {
            // 変更不可能なユーザデータ
            user_data: {
                // 会員番号
                member_no: "",
                // 氏名
                full_name: "",
                // 性別
                gender: "",
                // 生年月日
                birth_date: "",
                // メール
                mail: ""
            },
            page_title: '携帯番号変更',
            submit_disabled: true,
            valid: {
                mobile_number: false
            },
            valid_message: {
                mobile_number: ""
            },
            api_error: false,
            mobile_number: "",
            err_msg_txt: "",
            confirmDialogSw: false,
            // 処理の結果のオブジェクト
            processing: {
                result: '1',
                resultText: '携帯番号の変更が完了しました。',
                btnDisabled: 0,
            },
            btnName: ''
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize: function() {
            this.GetLoginUserMemberStatus();
            this.setMember();
            if (process.env.MIX_APP_URL) {
                this.btnName = 'OK';
            } else {
                this.btnName = 'ログインページに戻る';
            }
        },
        /** --------------------------------------------
         * 会員情報を取得
         * -------------------------------------------- */
        setMember: function(member_no) {
            this.user_data.member_no = this.$store.state.auth.loginMember.member_no;
            this.user_data.full_name =
                this.$store.state.auth.loginMember.family_name +
                " " +
                this.$store.state.auth.loginMember.given_name;
            if (this.$store.state.auth.loginMember.gender === 0) {
                this.user_data.gender = "男性";
            } else if (this.$store.state.auth.loginMember.gender === 1) {
                this.user_data.gender = "女性";
            }
            this.user_data.birth_date = this.$store.state.auth.loginMember.birth_date;
            this.user_data.email = this.$store.state.auth.loginMember.email;
            this.mobile_number = this.$store.state.auth.loginMember.mobile_number;
        },
        /** ----------------------------------------------
         * バリデーションチェック
         * ---------------------------------------------- */
        checkInputData: function(event) {
            if (event.type === 'input') {
                if (event.target.value) {
                    if (event.target.id === "mobile_number") {
                        // 携帯番号チェック
                        this.valid_message.mobile_number = "";
                        this.valid.mobile_number = false;
                        if (!validater.checkStringLengthMax(event.target.value,11)) {
                            this.valid_message.mobile_number = this.$t("error.validation.length.mobileNumber");
                            this.valid.mobile_number = true;
                        } else if (!validater.checkmobilenumber(this.mobile_number)) {
                            this.valid_message.mobile_number = this.$t("error.validation.mobileNumber");
                            this.valid.mobile_number = true;
                        }
                    }
                } else {
                    // 未入力の場合
                    if (event.target.id === "mobile_number") {
                        this.valid_message.mobile_number = "";
                        this.valid.mobile_number = false;
                    }
                }
            } else {
                if (event.target.value) {
                    if (event.target.id === "mobile_number") {
                        // 携帯番号チェック
                        this.valid_message.mobile_number = "";
                        this.valid.mobile_number = false;
                        if (!validater.checkStringLengthMax(event.target.value,11)) {
                            this.valid_message.mobile_number = this.$t("error.validation.length.mobileNumber");
                            this.valid.mobile_number = true;
                        } else if (!validater.checkmobilenumber(this.mobile_number)) {
                            this.valid_message.mobile_number = this.$t("error.validation.mobileNumber");
                            this.valid.mobile_number = true;
                        }
                    }
                }
            }
            this.disabledCheck();
        },
        /** ----------------------------------------------
         * 携帯番号を変更ボタン制御処理
         * ---------------------------------------------- */
        disabledCheck: function() {
            if (
                this.valid.mobile_number === false // バリデーションに問題ない場合のみ
            ) {
                this.submit_disabled = false; // ボタン押下可能
            } else {
                this.submit_disabled = true;
            }
        },
        /** ----------------------------------------------
         * 携帯番号変更ボタン押下時処理
         * ---------------------------------------------- */
        submitChangeMobile: async function () {
            this.$store.commit("loading/setIsLoading", true);
            try {
                let res = await this.$apollo.mutate({
                    mutation: UPDATE_MYPAGE_MOBILE,
                    variables: {
                        mobile_number: this.mobile_number
                    }
                });

                if (res.data.memberUpdateMobile.result === 1) {
                    if (process.env.MIX_APP_URL) {

                    } else {
                        this.logOut();
                    }
                    this.confirmDialogSw = true;
                    this.$store.commit("loading/setIsLoading", false);
                    // this.$router.push({ path: '/mypage-mobile-complete' });
                } else {
                    this.$store.commit("loading/setIsLoading", false);
                }
            } catch (error) {
                if (error.graphQLErrors[0].message == "The given data was invalid.") {
                    this.valid.mobile_number = true;
                    this.valid_message.mobile_number = this.$t("error.validation.mobileNumber");
                } else {
                    this.valid.mobile_number = true;
                    this.valid_message.mobile_number = error.graphQLErrors[0].message;
                }

                this.$store.commit("loading/setIsLoading", false);
            }
        },
        /** ----------------------------------------------
         * 戻るボタンの処理 会員情報参照画面へ
         * ---------------------------------------------- */
        gotoMypageInfo: function () {
            this.$router.push({ path: '/mypage-info' });
        },
        /** ----------------------------------------------
         * ログアウト処理
         * ---------------------------------------------- */
        logOut: function () {
            this.$store.commit("loading/setIsLoading", true);
            this.$apollo.query({
                query: MEMBER_LOG_OUT,
                variables: {}
            }).then(res => {
                localStorage.removeItem('web-token');
                this.$store.commit("loading/setIsLoading", false);
            }).catch(error => {
                this.$store.commit("loading/setIsLoading", false);
            });
        },
        onSignupForm: function () {
            if (process.env.MIX_APP_URL) {
                this.$router.push({ path: '/mypage' });
            } else {
                this.$router.push({ path: '/' });
            }
        }
    }
}

</script>

<style scoped>
@media screen and (max-width: 575px) {
    .mail-confirm-br {
        display: none;
    }
}
</style>
